import React from 'react';

import Lozenge, { type LozengeProps, type SemanticColor } from '@atlaskit/lozenge';

/**
 * TODO: Remove this override once the new lozenge is fully migrated
 */
type LozengePropsWithSemanticColor = Omit<LozengeProps, 'appearance'> & {
	appearance: SemanticColor;
};

const stateLozengePropsMap: Record<string, LozengePropsWithSemanticColor> = {
	ACTIVE: {
		appearance: 'success',
	},
	ARCHIVED: {
		appearance: 'neutral',
	},
	PENDING: {
		appearance: 'neutral',
	},
};

/**
 * @param state - The status of the compass component (e.g., 'PENDING', 'ACTIVE', 'ARCHIVED').
 */
export type SearchResultCompassStatusLozengeProps = {
	state?: string | null;
};

export const SearchResultCompassStatusLozenge = ({
	state,
}: SearchResultCompassStatusLozengeProps): React.JSX.Element | null => {
	if (!state) {
		return null;
	}

	const lozengeProps: LozengePropsWithSemanticColor = {
		appearance: 'neutral',
		isBold: true,
		...(state ? stateLozengePropsMap?.[state] : {}),
	};

	return <Lozenge {...lozengeProps}>{state}</Lozenge>;
};
